@if (isConversationLimitNoticeVisible$ | async) {
  <div
    class="conversation-limits-notice"
    (appOnVisible)="onLimitBannerVisible()"
  >
    <span class="conversation-limits-copy"
      >Free plan conversation limits apply.</span
    >
    <a class="conversation-limits-action celo-link" (click)="onLearnMoreClick()"
      >Learn more</a
    >
  </div>
}

<button mat-button class="group" (click)="handleGroupClick()">
  <div class="button-content">
    <span class="button-label">
      <mat-icon svgIcon="new-group"></mat-icon>
      <span>New Group</span>
    </span>
    @if (groupConversationRemainingText$ | async; as remainingText) {
      <span class="remaining-text">
        {{ remainingText }}
      </span>
    }
  </div>
</button>

<button mat-button class="case" (click)="handleCaseClick()">
  <div class="button-content">
    <span class="button-label">
      <mat-icon svgIcon="new-case"></mat-icon>
      <span>New Case</span>
    </span>
    @if (caseConversationRemainingText$ | async; as remainingText) {
      <span class="remaining-text">
        {{ remainingText }}
      </span>
    }
  </div>
</button>

@if (isNewExternalChatEnabled$ | async) {
  <button mat-button class="external" (click)="handleExternalClick()">
    <div class="button-content">
      <span class="button-label">
        <mat-icon svgIcon="new-external"></mat-icon>
        <span>New External Chat</span>
      </span>
    </div>
  </button>
}
